import { userService } from "../services";
import config from "../config/config";

export const CompanyAndUsersData = {
  fetchCompanyAndUserList,
  fetchCompanyUpdateByID,
};
async function fetchCompanyAndUserList() {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.companyAndUsers}`;
    const response = await userService.get(apiEndpoint);
    if (response && response.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function fetchCompanyUpdateByID(payload) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.updateCompanyById}`;
    const response = await userService.post(apiEndpoint, payload);
    if (response && response.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}
